// src/pages/ForgotPassword/ForgotPassword.jsx
import React, { useState } from 'react';
import axios from 'axios';

export default function ForgotPassword() {
  const connection = process.env.REACT_APP_API_URL; // e.g. "/api" or "https://api.yoursite.com/api"

  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setMsg(null);
    setErr(null);

    try {
      const normalized = (email || '').trim().toLowerCase();
      await axios.post(`${connection}/auth/request-password-reset`, { email: normalized });
      setMsg('If this email exists, a reset link has been sent.');
      setEmail('');
    } catch (e) {
      const apiMsg = e?.response?.data?.message || e.message || 'Something went wrong';
      setErr(apiMsg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={styles.wrap}>
      <h1 style={styles.h1}>Forgot your password?</h1>
      <p style={styles.p}>Enter your email and we’ll send you a reset link.</p>

      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>
          Email
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            style={styles.input}
            autoComplete="email"
            inputMode="email"
          />
        </label>

        <button type="submit" style={styles.button} disabled={busy || !email}>
          {busy ? 'Sending…' : 'Send reset link'}
        </button>

        {msg && <div style={{ ...styles.alert, ...styles.ok }}>{msg}</div>}
        {err && <div style={{ ...styles.alert, ...styles.bad }}>{err}</div>}
      </form>
    </div>
  );
}

const styles = {
  wrap: { maxWidth: 420, margin: '40px auto', padding: 20, fontFamily: '-apple-system,Roboto,Arial,sans-serif' },
  h1: { margin: '0 0 8px' },
  p: { color: '#5a6a64' },
  form: { display: 'grid', gap: 12, marginTop: 16 },
  label: { display: 'grid', gap: 6, fontSize: 14 },
  input: { padding: '10px 12px', borderRadius: 10, border: '1px solid #ccd2ce', fontSize: 16, width: '100%' },
  button: { padding: '12px 16px', borderRadius: 10, border: 'none', background: '#374845', color: '#fff', cursor: 'pointer' },
  alert: { padding: '10px 12px', borderRadius: 8, fontSize: 14, marginTop: 8 },
  ok: { background: '#e9f7ef', color: '#1e7a46' },
  bad: { background: '#fdecea', color: '#b23a2a' },
};
